import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=3f8e25e8&lang=pug&"
import script from "./Slides.vue?vue&type=script&lang=ts&"
export * from "./Slides.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports